const DB_NAME = "storedb";
const WISHLIST_TABLE = "wishlist";
const ORDER_TABLE = "order";
const DB_VERSION = 2;
let DB;
export default {
    async getDb() {
        return new Promise((resolve, reject) => {
            if (DB) {
                return resolve(DB);
            }
            const request = window.indexedDB.open(DB_NAME, DB_VERSION);
            request.onerror = (e) => {
                console.log("Error opening db", e);
                indexedDB.deleteDatabase(DB_NAME);
                // this.getDb();
                reject(e);
                // reject("Error");
            };
            request.onsuccess = (e) => {
                DB = e.target.result;
                resolve(DB);
            };
            request.onupgradeneeded = () => {
                let db = request.result;
                db.createObjectStore(WISHLIST_TABLE);
                db.createObjectStore(ORDER_TABLE);
                // let transaction = e.target.transaction;
                // if (db.objectStoreNames.contains(WISHLIST_TABLE)) {
                //     db.transaction([WISHLIST_TABLE], "readwrite")
                //         .objectStore(WISHLIST_TABLE)
                //         .clear();
                // } else {
                // }
                // if (db.objectStoreNames.contains(ORDER_TABLE)) {
                //     db.transaction([ORDER_TABLE], "readwrite")
                //         .objectStore(ORDER_TABLE)
                //         .clear();
                // } else {
                // }
                // console.log(`transaction =>`, transaction);
                // if (transaction.mode == "versionchange") {
                //     transaction.oncomplete = function(event) {
                //     };
                // }
            };
        });
    },
    async deleteWishlistItem(item) {
        const db = await this.getDb();
        return new Promise((resolve) => {
            const trans = db.transaction([WISHLIST_TABLE], "readwrite");
            trans.oncomplete = () => {
                resolve();
            };
            const store = trans.objectStore(WISHLIST_TABLE);
            store.delete(item);
        });
    },
    async getWishlist() {
        let db = await this.getDb();
        return new Promise((resolve) => {
            let trans = db.transaction([WISHLIST_TABLE], "readonly");
            trans.oncomplete = () => {
                resolve(items);
            };
            const store = trans.objectStore(WISHLIST_TABLE);
            const items = [];
            store.openCursor().onsuccess = (e) => {
                const cursor = e.target.result;
                if (cursor) {
                    items.push(cursor.value);
                    cursor.continue();
                }
            };
        });
    },
    async saveWishlistItem(item) {
        let db = await this.getDb();
        return new Promise((resolve) => {
            let trans = db.transaction([WISHLIST_TABLE], "readwrite");
            trans.oncomplete = () => {
                resolve();
            };
            let store = trans.objectStore(WISHLIST_TABLE);
            store.put(item, item);
        });
    },

    async clearWishlist() {
        const db = await this.getDb();
        return new Promise((resolve, reject) => {
            const trans = db.transaction([WISHLIST_TABLE], "readwrite");
            trans.oncomplete = () => {
                resolve();
            };
            trans.onerror = (e) => {
                reject(e);
            };
            trans.objectStore(WISHLIST_TABLE).clear();
        });
    },

    async getOrder() {
        let db = await this.getDb();
        return new Promise((resolve) => {
            let trans = db.transaction([ORDER_TABLE], "readonly");
            trans.oncomplete = () => {
                resolve(items);
            };
            const store = trans.objectStore(ORDER_TABLE);
            const items = {};
            store.openCursor().onsuccess = (e) => {
                const cursor = e.target.result;
                if (cursor) {
                    items[cursor.key] = cursor.value;
                    cursor.continue();
                }
            };
        });
    },
    async clearOrder() {
        const db = await this.getDb();

        return new Promise((resolve, reject) => {
            const transaction = db.transaction(ORDER_TABLE, "readwrite");
            const store = transaction.objectStore(ORDER_TABLE);

            store.clear();

            transaction.oncomplete = () => {
                // eslint-disable-next-line no-console
                console.log("order cleared resolve");
                resolve();
            };

            transaction.onerror = (e) => {
                reject(e);
            };
        });
    },

    async saveOrderItem(item) {
        let db = await this.getDb();
        return new Promise((resolve) => {
            let trans = db.transaction([ORDER_TABLE], "readwrite");
            trans.oncomplete = () => {
                resolve();
            };
            let store = trans.objectStore(ORDER_TABLE);
            store.put(item, item.key);
        });
    },

    async deleteOrderItem(key) {
        const db = await this.getDb();
        return new Promise((resolve) => {
            const trans = db.transaction([ORDER_TABLE], "readwrite");
            trans.oncomplete = () => {
                resolve();
            };
            const store = trans.objectStore(ORDER_TABLE);
            store.delete(key);
        });
    },
};
